import { tickerItems } from "@/mocks/homeContent";

export default function UpdateBar() {
  const loop = [...tickerItems, ...tickerItems];
  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="mx-auto flex w-full max-w-[1280px] items-center gap-3 px-4 py-2 md:gap-4 md:px-6">
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500/20 px-2.5 py-0.5 text-xs font-semibold text-primary-100">
          <span className="h-1.5 w-1.5 rounded-full bg-primary-400 animate-pulse-dot" />
          现场更新
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap text-xs text-foreground-200 md:text-[13px]">
            {loop.map((item, i) => (
              <span key={i} className="inline-flex items-center gap-8">
                <span className="inline-flex items-center gap-2">
                  <i className="ri-flashlight-fill text-accent-400" />
                  {item}
                </span>
                <i className="ri-arrow-drop-right-line text-foreground-600" />
              </span>
            ))}
          </div>
        </div>
        <span className="hidden shrink-0 items-center gap-1 text-xs text-foreground-400 md:inline-flex">
          <i className="ri-time-line" />
          2026.09.06
        </span>
      </div>
    </div>
  );
}